// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"qy_a","PostMenu__item--moderator":"qy_b","PostMenu__item--author":"qy_c"};